<template>
    <div class="course-details__wrap">
        <div class="course-base-info">
            <h2 class="course-name">{{ courseBaseInfo.periodname || '--' }}</h2>
            <h3 class="class-name">{{ courseBaseInfo.classname || '--' }}</h3>
            <h3 class="class-name">{{ courseBaseInfo.name || '--' }}</h3>
            <ul class="course-data">
                <!-- <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.totalstudentcount }}</div>
                    <div class="course-data-item__label">学员总数</div>
                </li> -->
                <!-- <li class="course-data-item">
                    <div class="course-data-item__value">{{ `${courseBaseInfo.finishperiodcount}/${courseBaseInfo.periodcount}` }}</div>
                    <div class="course-data-item__label">课程进展</div>
                </li> -->
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.studystudentcount }}</div>
                    <div class="course-data-item__label">总学习人数</div>
                </li>
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.finishcoursecount }}</div>
                    <div class="course-data-item__label">完课人数</div>
                </li>
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.finishrate }}</div>
                    <div class="course-data-item__label">完课率</div>
                </li>
            </ul>
            <el-button @click="$router.go(-1)" class="btn-go-back" icon="el-icon-arrow-left">返回上级</el-button>
        </div>
        <el-tabs @tab-click="handleTabChange" v-model="activeTabName">
            <el-tab-pane label="考勤信息" name="attendanceInfo">
                <AttendanceInfo ref="attendanceInfo" :code="coursePeriodCode" :course-code="code" :class-code="classCode" />
            </el-tab-pane>
            <el-tab-pane label="学员信息" name="studentInfo">
                <StudentInfo :code="coursePeriodCode" :course-code="code" :class-code="classCode" />
            </el-tab-pane>
            <el-tab-pane label="作业信息" name="workInfo">
                <WorkList :periodcode="coursePeriodCode" :class-code="classCode" :class-course-code="code"></WorkList>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import AttendanceInfo from './components/attendanceInfo.vue'
import StudentInfo from './components/studentInfo.vue'
import WorkList from '@/views/meas/teachManagement/classManagement/classDetail/workList.vue'
import { getCourseperiodTopInfo } from '@/api/measApi/studyManagement'
export default {
  components: {
    AttendanceInfo,
    StudentInfo,
    WorkList
  },
  data: () => ({
    activeTabName: 'attendanceInfo',
    courseBaseInfo: {}
  }),
  computed: {
    // 课程code
    code() {
      return this.$route.query.code || ''
    },
    // 班级code
    classCode() {
      return this.$route.query.classCode || ''
    },
    // 课时code
    coursePeriodCode() {
        return this.$route.query.coursePeriodCode || ''
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.attendanceInfo.init()
    })
    this.getCourseperiodTopInfo()
  },
  methods: {
    handleTabChange(e) {
      e.$children[0].init(1)
    },
    // 获取课程顶部信息
    async getCourseperiodTopInfo() {
      const res = await getCourseperiodTopInfo({ code: this.coursePeriodCode })
      if (res.code === '000') {
        this.courseBaseInfo = res.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.course-details__wrap {
  padding: 0 0 20px;
}
::v-deep .el-dialog .el-dialog__body {
  height: calc(100% - 51px) !important;
}
.course-base-info {
  position: relative;
  padding: 20px;
  border-radius: 4px;
  background-color: #f6f7fb;

  > .btn-go-back {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
.course-name {
  font-size: 16px;
  color: #333;
}
.class-name {
  margin-top: 6px;
  font-size: 12px;
  line-height: 17px;
  color: #333;
}
.course-data {
  margin-top: 27px;
  display: flex;
  flex-wrap: wrap;
}
.course-data-item {
  flex-shrink: 0;
}
.course-data-item:not(:last-of-type) {
  margin-right: 60px;
  @media screen and (max-width: 850px) {
    margin-right: 20px;
  }
}
.course-data-item > div {
  text-align: center;
}
.course-data-item__value {
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  color: #333;
  font-weight: 600;
}
.course-data-item__label {
  margin-top: 8px;
  font-size: 12px;
  line-height: 17px;
  color: #666;
}
::v-deep .el-tabs {
  .el-tabs__item {
    padding: 0 20px !important;
    &.is-active {
      color: #4d5560 !important;
    }
    &:hover {
      color: #4d5560;
    }
    .el-tabs__nav-wrap::after {
      background-color: #f6f7fb;
    }
  }
}
</style>
